import { create } from 'zustand'
import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'

type AccountCreationFormState = {
	currentStep: number
	isFormValid: boolean
	/** STG follow-up: inherited account/tag fields are read-only. */
	stgFollowUpReadOnly: boolean
	formValues: Record<string, any>
}

type AccountCreationFormActions = {
	actions: {
		setFormValues: (fieldName: string, value: any) => void
		replaceFormValues: (values: Record<string, any>) => void
		setStgFollowUpReadOnly: (value: boolean) => void
		setCurrentStep: (step: number) => void
		setFormValidity: (isValid: boolean) => void
		clearFormValues: () => void
	}
}

const emptyNetworkFields = {
	vpcName: '',
	vpcCidrBlock: '',
	vpcAvailabilityZones: '',
	privateSubnetsCidr: '',
	tgwSubnetsCidr: '',
	requestTgwAttachment: 'true',
	isCoreVpc: 'false',
	createPrivateHostedZone: 'true',
	associateDnsResolverRules: 'true',
	useCentralizedVpcInterfaceEndpoints: 'true',
	privateHostedZoneName: ''
}

const initialFormValues = {
	//projectName: 'demo-project-name',
	accountTypes: [
		{
			label: 'Sandbox',
			value: 'Sandbox'
		}
	],
	// EKS | Non-EKS; default Non-EKS for backward compatibility (old requests/UI without toggle)
	accountWorkloadType: 'Non-EKS' as 'EKS' | 'Non-EKS',
	sandboxDistributionList: '',
	sandboxMonthlyBudgetCap: 1,
	sandboxSSOUserNames: [] as Array<{ userName: string; displayName: string }>,
	sandboxPlatformOwner: '',
	...emptyNetworkFields,
	addSecondaryCidrBlock: false,
	secondaryCidrBlock: '',
	addPublicCidrBlock: false,
	publicCidrBlock: '',
	ip_address_allocations: [] as Array<{
		id: string
		label: string
		cidrAzA: string
		cidrAzB: string
		cidrAzC?: string
	}>
}

const accountCreationFromStore = create<
	AccountCreationFormState & AccountCreationFormActions
>((set, _get) => ({
	currentStep: 0,
	isFormValid: false,
	stgFollowUpReadOnly: false,
	formValues: initialFormValues,
	actions: {
		clearFormValues: () =>
			set(() => ({
				formValues: initialFormValues,
				currentStep: 0,
				stgFollowUpReadOnly: false,
				isFormValid: false
			})),

		replaceFormValues: (values) =>
			set(() => ({
				formValues: { ...initialFormValues, ...values } as typeof initialFormValues
			})),

		setStgFollowUpReadOnly: (value) => set(() => ({ stgFollowUpReadOnly: value })),

		setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),

		setFormValues: (fieldName, value) =>
			set((state) =>
				produce(state, (draft) => {
					draft.formValues[fieldName] = value
				})
			),

		setCurrentStep: (step) => {
			set(() => ({
				currentStep: step
			}))
		}
	}
}))

export const useAccountCreationFormStore = () =>
	accountCreationFromStore((state) => state)

if (process.env.NODE_ENV !== 'production') {
	mountStoreDevtool('AccountCreationFormStore', accountCreationFromStore)
}
